import script from "./OtherUserProfileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtherUserProfileModal.vue?vue&type=script&setup=true&lang=ts"

import "./OtherUserProfileModal.vue?vue&type=style&index=0&id=5a8373bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8373bd"]])

export default __exports__